<template>
<div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

        <!-- Register v1 -->
        <b-card class="mb-0">
            <b-img thumbnail :src='detail.student.logo' fluid />
            <b-link class="brand-logo">

                <h2 class="brand-text text-primary">
                    {{ detail.student.client_name }}
                </h2>
            </b-link>

            <b-card-title class="mb-1">

            </b-card-title>
            <b-card-text class="mb-2">

            </b-card-text>

            <!-- form -->
            <validation-observer ref="registerForm">
                <h4 class="brand-text text-primary ml-1" v-if="valid === false">Invalid Link</h4>
                <b-form v-if="insert === false && valid === true">
                    <b-form-group label="Student Name 學生姓名" label-for="student_name">
                        <b-form-input id="student_name" v-model="detail.student.zh_name" trim readonly />

                    </b-form-group>

                    <b-form-group label="Mobile 聯絡電話" label-for="mobile">
                        <b-form-input id="mobile" v-model="detail.student.mobile" trim readonly />

                    </b-form-group>
                    <b-form-group label="Total Amount 應付金額" label-for="金額">
                        <b-input-group prepend="HKD">
                            <b-form-input readonly :value="formatAmount(detail.amount)" />
                        </b-input-group>
                    </b-form-group>

                    <b-form-group label="Prepaid Amount 已付金額" label-for="預付金額" v-if="detail.debit > 0">
                        <b-input-group prepend="HKD">
                            <b-form-input readonly :value="formatAmount(detail.debit)" />
                        </b-input-group>
                    </b-form-group>

                    <b-form-group label="Remaining Amount Payable 應付餘額" label-for="應付餘額">
                        <b-input-group prepend="HKD">
                            <b-form-input readonly :value="formatAmount(detail.amount - detail.debit)" />
                        </b-input-group>
                    </b-form-group>
                    <hr class="my-2" />
                    課程內容
                    <b-list-group>

                        <b-list-group-item class="flex-column align-items-start" v-for="detail in detail.classes" :key="detail.id">
                            <div class="d-flex w-100 justify-content-between">
                                <h5 class="mb-1">
                                    {{ detail.name }}
                                </h5>
                                <small class="text-secondary">HKD ${{ detail.price}} / session</small>
                            </div>
                            <ul>
                                <li v-for="enrollment in detail.enrollments" :key="enrollment.id"> <b>{{ enrollment.formatted_date }} </b> {{ enrollment.start }}-{{ enrollment.end }} <span v-if="admin === true">( #{{ enrollment.id }} )</span></li>
                            </ul>

                            <small class="text-secondary" variant="danger" v-if="detail.leave > 0">上月請假日數 : {{ detail.leave }}日</small>
                        </b-list-group-item>

                    </b-list-group>

                    <hr class="my-2" />
                    <div class="payment-info-block">
                        <h5 class="mb-1">Payment Information</h5>
                        <p class="mb-50">
                            <strong>Company Name:</strong>
                            Cloud Media
                        </p>
                        <p class="mb-50">
                            <b-link href="#" @click.prevent="$bvModal.show('modal-policy-terms')">Terms &amp; Conditions (T&amp;C)</b-link>
                        </p>
                        <p class="mb-50">
                            <b-link href="#" @click.prevent="$bvModal.show('modal-policy-privacy')">Privacy Policy</b-link>
                        </p>
                        <p class="mb-50">
                            <b-link href="#" @click.prevent="$bvModal.show('modal-policy-refund')">Refund Policy</b-link>
                        </p>
                        <p class="mb-0">
                            <strong>Contact Us:</strong>
                            {{ contactInfo }}
                        </p>
                    </div>

                    <!-- submit button -->
                    <!-- <b-button variant="primary" :disabled="paid" class="mt-2" block type="button" @click="submit_payment()">
                        Submit Payment
                    </b-button> -->
                    <div v-if="admin === true">
                    <hr />
                    <v-select
                        v-model="selected_payment.method"
                        :options="paymentMethods"
                        :reduce="method => method.value"
                        input-id="payment-method"
                        class="payment-selector"
                        :clearable="false"
                        />
                        <b-form-input type="text" class="mt-1"  v-model="selected_payment.amount" placeholder="金額 Amount" />
                    <b-button v-if="admin === true" variant="danger" :disabled="paid" class="my-2 mb-5" block type="button" @click="submit_payment()">
                        Approve By Admin
                    </b-button>
                    </div>
                </b-form>
            </validation-observer>

        </b-card>

        <b-modal
            id="modal-policy-terms"
            title="Terms & Conditions (T&C)"
            ok-only
            ok-title="Close"
            scrollable
        >
            <h6>1. Introduction</h6>
            <p>These Terms and Conditions ("Terms") govern the use of the CloudEdu online payment system and related services provided by Cloud Media ("CloudEdu", "we", "our", or "us").</p>
            <p>By making a payment through the CloudEdu platform, you agree to be bound by these Terms and Conditions. If you do not agree with these Terms, you should not use this service.</p>

            <h6>2. Services</h6>
            <p>CloudEdu provides a digital platform that allows students, parents, or guardians to make payments for:</p>
            <ul>
                <li>Tuition fees</li>
                <li>Course enrollment fees</li>
                <li>Class packages</li>
                <li>Educational services</li>
                <li>Other related services offered by partner education centers</li>
            </ul>
            <p>Payments made through the CloudEdu platform are processed via QFPay, a third-party payment service provider. CloudEdu does not store or process credit card information directly.</p>

            <h6>3. Payment Processing</h6>
            <p>All payments are securely processed through QFPay. By making a payment, you acknowledge and agree that:</p>
            <ul>
                <li>Your payment information will be transmitted to QFPay</li>
                <li>QFPay may apply its own terms and security policies</li>
                <li>CloudEdu is not responsible for payment gateway errors or banking delays</li>
            </ul>
            <p>Accepted payment methods may include:</p>
            <ul>
                <li>Credit / Debit Card</li>
                <li>Apple Pay</li>
                <li>Google Pay</li>
                <li>Alipay / WeChat Pay (if enabled)</li>
            </ul>
            <p>Payment confirmation is generated only after successful authorization from the payment gateway.</p>

            <h6>4. Account Responsibility</h6>
            <p>Users are responsible for:</p>
            <ul>
                <li>Providing accurate information when making payments</li>
                <li>Ensuring correct student or account details</li>
                <li>Keeping their account credentials secure</li>
            </ul>
            <p>CloudEdu shall not be responsible for payments made using incorrect information provided by the user.</p>

            <h6>5. Course and Service Policies</h6>
            <p>Educational services, schedules, class availability, and course content are determined by the respective education centers using CloudEdu.</p>
            <p>CloudEdu acts as a technology platform provider and does not manage class operations directly.</p>
            <p>Any disputes regarding class scheduling, instructor availability, course content, and attendance policies should be addressed with the respective education center.</p>

            <h6>6. Limitation of Liability</h6>
            <p>CloudEdu shall not be liable for any indirect, incidental, or consequential damages resulting from:</p>
            <ul>
                <li>Payment processing delays</li>
                <li>Service interruptions</li>
                <li>Errors caused by third-party systems</li>
                <li>Banking network failures</li>
            </ul>
            <p>Our total liability shall not exceed the amount paid for the relevant service.</p>

            <h6>7. Service Availability</h6>
            <p>CloudEdu strives to maintain continuous service availability but does not guarantee uninterrupted access.</p>
            <p>We reserve the right to suspend services for maintenance, update system functionality, and modify or discontinue services when necessary.</p>

            <h6>8. Changes to Terms</h6>
            <p>CloudEdu may update these Terms from time to time. Updated versions will be published on our website and will take effect immediately upon posting.</p>

            <h6>9. Governing Law</h6>
            <p>These Terms shall be governed by and interpreted in accordance with the laws of Hong Kong SAR.</p>

            <h6>10. Contact Information</h6>
            <p class="mb-0">For any inquiries regarding these Terms, please contact: Cloud Media, Email: support@cloudedu.pro</p>
        </b-modal>

        <b-modal
            id="modal-policy-privacy"
            title="Privacy Policy"
            ok-only
            ok-title="Close"
            scrollable
        >
            <h6>1. Introduction</h6>
            <p>CloudEdu respects your privacy and is committed to protecting personal data in accordance with applicable privacy laws, including the Hong Kong Personal Data (Privacy) Ordinance (PDPO).</p>

            <h6>2. Information We Collect</h6>
            <p>We may collect the following information when users make payments:</p>
            <p><strong>Personal Information</strong></p>
            <ul>
                <li>Student name</li>
                <li>Parent / guardian name</li>
                <li>Email address</li>
                <li>Phone number</li>
            </ul>
            <p><strong>Transaction Information</strong></p>
            <ul>
                <li>Payment amount</li>
                <li>Payment time</li>
                <li>Transaction ID</li>
                <li>Course or service purchased</li>
            </ul>
            <p><strong>Technical Information</strong></p>
            <ul>
                <li>IP address</li>
                <li>Device information</li>
                <li>Browser type</li>
                <li>Usage logs</li>
            </ul>

            <h6>3. Purpose of Data Collection</h6>
            <p>Personal data may be used for:</p>
            <ul>
                <li>Processing payments</li>
                <li>Managing student enrollment</li>
                <li>Providing customer support</li>
                <li>Generating invoices or receipts</li>
                <li>Improving system performance</li>
                <li>Preventing fraud and security risks</li>
            </ul>

            <h6>4. Payment Security</h6>
            <p>All payment transactions are processed via QFPay, a secure third-party payment processor.</p>
            <p>CloudEdu does not store full credit card numbers. Payment information is handled directly by the payment gateway in accordance with their security standards.</p>

            <h6>5. Data Sharing</h6>
            <p>CloudEdu may share relevant information with:</p>
            <ul>
                <li>Partner education centers</li>
                <li>Payment processors (QFPay)</li>
                <li>Regulatory authorities when legally required</li>
            </ul>
            <p>We do not sell or rent personal information to third parties.</p>

            <h6>6. Data Retention</h6>
            <p>Personal data will be retained only as long as necessary to provide services, comply with legal obligations, resolve disputes, and maintain financial records.</p>

            <h6>7. User Rights</h6>
            <p>Users may request to access their personal data, correct inaccurate information, and request deletion of certain data where legally permissible. Requests can be submitted via email.</p>

            <h6>8. Data Security</h6>
            <p>CloudEdu implements appropriate technical and organizational measures to protect personal data against unauthorized access, data loss, misuse, and alteration.</p>

            <h6>9. Cookies</h6>
            <p>Our platform may use cookies or similar technologies to improve user experience and analyze system usage. Users may disable cookies through their browser settings.</p>

            <h6>10. Contact</h6>
            <p class="mb-0">Privacy inquiries can be directed to: privacy@cloudedu.pro</p>
        </b-modal>

        <b-modal
            id="modal-policy-refund"
            title="Refund Policy"
            ok-only
            ok-title="Close"
            scrollable
        >
            <h6>1. General Policy</h6>
            <p>Refund requests are subject to the policies of the respective education center providing the course or service. CloudEdu acts as a payment platform and does not determine refund eligibility.</p>

            <h6>2. Refund Eligibility</h6>
            <p>Refunds may be considered in situations such as:</p>
            <ul>
                <li>Course cancellation by the education center</li>
                <li>Duplicate payments</li>
                <li>Payment errors</li>
            </ul>
            <p>Refund approval is at the discretion of the education center.</p>

            <h6>3. Non-Refundable Items</h6>
            <p>The following may not be refundable unless required by law:</p>
            <ul>
                <li>Completed classes</li>
                <li>Partially used class packages</li>
                <li>Administrative fees</li>
                <li>Promotional or discounted packages</li>
            </ul>

            <h6>4. Refund Process</h6>
            <p>To request a refund, users should contact the respective education center with student name, payment receipt, transaction ID, and reason for refund.</p>
            <p>If approved, refunds will be processed via the original payment method.</p>

            <h6>5. Processing Time</h6>
            <p>Refund processing time may vary depending on the payment provider and bank policies. Typical processing time: 5–14 business days.</p>

            <h6>6. Transaction Fees</h6>
            <p class="mb-0">Payment processing fees charged by the payment gateway may be non-refundable.</p>
        </b-modal>

        <!-- /Register v1 -->
    </div>
</div>
</template>

  
  
<script>
import {
    ValidationProvider,
    ValidationObserver
} from 'vee-validate'
import vSelect from 'vue-select'

import {
    BCard,
    BLink,
    BCardTitle,
    BCardText,
    BForm,
    BImg,
    BRow,
    BListGroup,
    BListGroupItem,
    BCol,
    BBadge,
    BButton,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    BModal,
} from 'bootstrap-vue'
import router from '@/router'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
    required,
    email
} from '@validations'
import {
    togglePasswordVisibility
} from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
    components: {
        VuexyLogo,
        BListGroup,
        BListGroupItem,
        vSelect,
        // BSV
        BCard,
        BBadge,
        BRow,
        BCol,
        BImg,
        BLink,
        BCardTitle,
        router,
        BCardText,
        BForm,
        BButton,
        BFormInput,
        BFormGroup,
        BInputGroup,
        BInputGroupAppend,
        BFormCheckbox,
        BModal,
        // validations
        ValidationProvider,
        ValidationObserver,
    },
    mixins: [togglePasswordVisibility],
    data() {
        return {
            paymentMethods: [ {value:'ONLINE',label:'Online'},{value:'CASH',label:'Cash'},{value:'FPS',label:'轉數快'},{value:'PAYME',label:'PayMe'},{value:'Chueqe',label:'支票'}],
            regEmail: '',
            qfpay: null,
            selected_payment: {
                method: 'ONLINE',
                amount: 0
            },
            detail: null,
            username: '',
            valid: true,
            password: '',
            admin: false,
            status: '',
            insert: false,
            paid: false,
            member: {
                member_code: null,
                mobile: null
            },
            contactInfo: 'Cloud Media  | support@cloudedu.pro',
            card: {
                number: null,
                expire: null,
                cvc: null,
                center_id: router.currentRoute.params.center_id
            },
            // validation rules
            required,
            email,
        }
    },
    computed: {
        passwordToggleIcon() {
            return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
        },
    },
    created() {
        this.get_detail()
        if (this.$route.query.role == 'admin') {
            this.admin = true;
        }
    },
    methods: {
          formatAmount(value) {
          return Number(value).toFixed(2);
        },
        submit_payment() {
           
            if (this.detail.amount == 0 || this.admin === true) {
                this.$http.post(process.env.VUE_APP_API_BASE + '/payment_gateway/free-transaction/' + router.currentRoute.params.student_uuid + '/' + router.currentRoute.params.date + '/', { detail : this.detail,payment: this.selected_payment })
                    .then(res => {
                        if (res.data.result === true) {
                            this.$swal({
                                title: 'Success!',
                                text: 'Payment has been processed successfully!',
                                icon: 'success',
                                showConfirmButton: false,
                                buttonsStyling: false,
                                backdrop: false,
                            })
                            this.paid = true
                        }
                        return
                        window.location.href = res.data.url
                    })
            } else {
                this.detail.payment_target = router.currentRoute.params.date
                this.$http.post(process.env.VUE_APP_API_BASE + '/payment_gateway/qfpay-sdk/', this.detail)
                    .then(res => {
                        this.qfpay = res.data
                        window.location.href = this.qfpay.url
                    })
            }
        },
        get_detail() {
            this.$http.get(process.env.VUE_APP_API_BASE + `/schedule-payment/` + router.currentRoute.params.student_uuid + `/` + router.currentRoute.params.date + `/`)
                .then(res => {
                    if (res.data.result === false) {
                        this.valid = false
                    } else {
                        this.detail = res.data
                    }
                })
        },
        add_card() {
            this.$http.post(process.env.VUE_APP_API_BASE + '/member/token/' + router.currentRoute.params.token + '/credit_card/add/', this.card)
                .then(res => {
                    if (res.data.result === true) {
                        this.insert = true
                        this.card.number = null
                        this.card.expire = null
                        this.card.cvc = null
                        this.$swal({
                            title: 'Success!',
                            text: 'You inserted a valid credit card!',
                            icon: 'success',
                            showConfirmButton: false,
                            buttonsStyling: false,
                            backdrop: false,
                        })
                    } else {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Error',
                                icon: 'XIcon',
                                variant: 'danger',
                                text: res.data.message,
                            },
                        })
                    }
                })
        },
    },
}
</script>
  
  
<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

.payment-info-block {
    font-size: 0.9rem;
    line-height: 1.6;
}

.payment-info-block a {
    text-decoration: underline;
}
</style>
